import { useState } from 'react';
import { useCollapse } from 'react-collapsed';

// react-collapsed gives a non-button toggle role="button" and tabIndex, but no key handling.
// Keys pressed on buttons inside the header (actions) are left to those buttons.
const onEnterOrSpace = (callback) => (e) => {
  if (e.target !== e.currentTarget) return;
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    callback();
  }
};

// `actions` (a node, or a function of isExpanded) sit at the right of the header; they stop click
// propagation themselves so they don't toggle the section
const CollapsibleSection = ({ title, titleClassName = 'member-info-subtitle', actions, children }) => {
  const [isExpanded, setExpanded] = useState(true);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });
  const toggle = () => setExpanded((prevExpanded) => !prevExpanded);

  return (
    <div className={`border-bottom ${isExpanded ? 'pb-3' : ''}`}>
      <div
        className={`${isExpanded ? 'pt-3' : 'py-3'} pointer px-4 toggle-no-button${
          actions ? ' flex-centered justify-content-between' : ''
        }`}
        {...getToggleProps({ onClick: toggle, onKeyDown: onEnterOrSpace(toggle) })}
      >
        <h4 className={`category-subtitle ${titleClassName} dropdown-item-element ${isExpanded ? 'open' : ''}`}>
          {title}
        </h4>
        {typeof actions === 'function' ? actions(isExpanded) : actions}
      </div>
      <div {...getCollapseProps()} className='px-4'>
        {children}
      </div>
    </div>
  );
};

export { onEnterOrSpace };
export default CollapsibleSection;
